import LegalLayout from '../components/LegalLayout';

const navLinks = [
  { label: 'Ochrana súkromia', href: '/ochrana-sukromia' },
  { label: 'Cookies', href: '/cookies' },
];

const sections = [
  {
    title: 'Základné ustanovenia',
    content: (
      <>
        <p>Tieto obchodné podmienky (ďalej len „Podmienky") upravujú vzájomné práva a povinnosti medzi <strong className="text-white">Kamilom Frajtkom – Boostio</strong>, IČO: 54 125 481, DIČ: 1127687165, Ruská Nová Ves 16, 080 05 Prešov, neplatca DPH (ďalej len „Poskytovateľ") a klientom (ďalej len „Klient") pri poskytovaní digitálnych služieb.</p>
        <p>Uzatvorením zmluvy, odoslaním objednávky alebo potvrdením cenovej ponuky Klient potvrdzuje, že sa oboznámil s týmito Podmienkami a súhlasí s ich záväznosťou.</p>
      </>
    ),
  },
  {
    title: 'Predmet zmluvy a rozsah služieb',
    content: (
      <>
        <p>Predmetom zmluvy je poskytovanie digitálnych služieb, najmä:</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>Tvorba webových stránok a e-shopov</li>
          <li>Správa online marketingu (Google Ads, Meta Ads, SEO)</li>
          <li>Správa sociálnych sietí a tvorba obsahu</li>
          <li>Vývoj vlastných digitálnych systémov a automatizácií</li>
          <li>Dlhodobá technická a marketingová podpora</li>
        </ul>
        <p className="mt-3">Konkrétny rozsah, termíny a cena sú stanovené v individuálnej Zmluve o dielo alebo Cenovej ponuke, ktorú Poskytovateľ zasiela Klientovi e-mailom. Podmienky sú súčasťou každej takejto zmluvy.</p>
      </>
    ),
  },
  {
    title: 'Ceny a platobné podmienky',
    content: (
      <>
        <p>Ceny sú stanovené individuálne na základe rozsahu projektu a sú uvedené v Cenovej ponuke. Všetky ceny sú uvedené bez DPH, ak nie je výslovne uvedené inak.</p>
        <p>Štandardné platobné podmienky:</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li><strong className="text-zinc-300">Záloha 50 %</strong> - splatná pred začatím prác</li>
          <li><strong className="text-zinc-300">Doplatenie 50 %</strong> - splatné pred odovzdaním finálneho výstupu</li>
          <li>Pre projekty do 500 € sa môže vyžadovať platba vopred v plnej výške</li>
          <li>Mesačné platby za správu a marketing sú splatné vždy k 5. dňu príslušného mesiaca</li>
        </ul>
        <p className="mt-3">Pri omeškaní platby je Poskytovateľ oprávnený účtovať úrok z omeškania vo výške 0,05 % z dlžnej sumy za každý deň omeškania.</p>
      </>
    ),
  },
  {
    title: 'Termíny a dodanie',
    content: (
      <>
        <p>Termíny dodania sú stanovené v Zmluve. Plnenie termínov závisí od riadneho a včasného plnenia povinností Klienta, najmä:</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>Poskytnutia potrebných podkladov (texty, fotografie, prístupy)</li>
          <li>Schválenia jednotlivých etáp projektu</li>
          <li>Uhradenia platobných záväzkov podľa harmonogramu</li>
        </ul>
        <p className="mt-3">Ak Klient neposkytne podklady včas, termín dodania sa posúva o rovnaký počet dní, o ktorý bol v omeškaní Klient. Poskytovateľ Klienta na omeškanie upozorní e-mailom.</p>
      </>
    ),
  },
  {
    title: 'Reklamácie a záruky',
    content: (
      <>
        <p>Poskytovateľ zodpovedá za to, že dielo bude zhotovené podľa dohodnutej špecifikácie. Klient je povinný skontrolovať odovzdané dielo bezodkladne po jeho prevzatí.</p>
        <p className="mt-2">Reklamáciu je Klient povinný uplatniť do <strong className="text-zinc-300">14 dní</strong> od prevzatia diela, a to písomne na adresu <a href="mailto:info@boostio.sk" className="text-orange-400 hover:underline">info@boostio.sk</a>. Reklamácia musí obsahovať popis vady a prílohy (snímky obrazovky, URL).</p>
        <p className="mt-2">Záručná doba na webové projekty je <strong className="text-zinc-300">6 mesiacov</strong> od odovzdania a vzťahuje sa výlučne na technické chyby spôsobené Poskytovateľom, nie na zmeny obsahu, zmeny tretích strán alebo nesprávne používanie.</p>
      </>
    ),
  },
  {
    title: 'Duševné vlastníctvo',
    content: (
      <>
        <p>Po úplnom uhradení celej ceny za dielo prechádzajú na Klienta výhradné majetkové práva k výsledkom tvorivej činnosti (grafické návrhy, texty, kód) v rozsahu dohodnutom v Zmluve.</p>
        <p className="mt-2">Pokiaľ nie je uhradená celá cena, zostávajú všetky práva na strane Poskytovateľa a Klient nie je oprávnený dielo ďalej šíriť, predávať ani používať komerčne.</p>
        <p className="mt-2">Poskytovateľ si vyhradzuje právo uviesť zrealizovaný projekt v portfóliu a referencovaných materiáloch, pokiaľ Klient výslovne nepožiadal o diskrétnosť.</p>
      </>
    ),
  },
  {
    title: 'Mlčanlivosť',
    content: (
      <>
        <p>Obe strany sa zaväzujú zachovávať mlčanlivosť o dôverných informáciách druhej strany, ktoré sa dozvedeli v súvislosti s plnením zmluvy. Za dôverné sa považujú najmä: obchodné stratégie, cenové kalkulácie, technické špecifikácie a osobné údaje.</p>
        <p className="mt-2">Táto povinnosť trvá počas trvania zmluvného vzťahu aj po jeho skončení, a to po dobu <strong className="text-zinc-300">3 rokov</strong>.</p>
      </>
    ),
  },
  {
    title: 'Zodpovednosť za škodu',
    content: (
      <>
        <p>Zodpovednosť Poskytovateľa za škodu je obmedzená výškou ceny, ktorú Klient uhradil za príslušnú službu. Poskytovateľ nezodpovedá za nepriame škody, ušlý zisk ani stratu údajov.</p>
        <p className="mt-2">Klient nesie plnú zodpovednosť za obsah, ktorý Poskytovateľovi poskytne na zverejnenie (texty, obrázky, videá). Klient vyhlasuje, že disponuje príslušnými licenciami a oprávneniami.</p>
      </>
    ),
  },
  {
    title: 'Ukončenie zmluvy',
    content: (
      <>
        <p>Každá zo strán môže ukončiť zmluvu o dlhodobej spolupráci (správa marketingu, sociálnych sietí) výpoveďou s <strong className="text-zinc-300">výpovednou dobou 1 mesiac</strong>, pričom výpovedná doba začína plynúť prvým dňom nasledujúceho mesiaca.</p>
        <p className="mt-2">Pri projektovej zmluve (jednorazové dielo) je ukončenie pred dokončením možné len po vzájomnej dohode. Práce vykonané do dátumu ukončenia budú fakturované pomerne.</p>
      </>
    ),
  },
  {
    title: 'Záverečné ustanovenia',
    content: (
      <>
        <p>Tieto Podmienky sa riadia právnym poriadkom Slovenskej republiky. Pre prípad sporov sa obe strany zaväzujú riešiť ich prednostne mimosúdnou cestou.</p>
        <p className="mt-2">Poskytovateľ si vyhradzuje právo Podmienky jednostranne meniť. O zmene informuje Klienta e-mailom aspoň <strong className="text-zinc-300">14 dní</strong> pred nadobudnutím účinnosti zmeny. Pokračovanie v spolupráci po nadobudnutí účinnosti zmeny sa považuje za súhlas s novými Podmienkami.</p>
        <p className="mt-2">Tieto Podmienky nadobúdajú účinnosť dňa <strong className="text-zinc-300">1. januára 2024</strong>.</p>
      </>
    ),
  },
];

export default function ObchodnePodmienkyPage() {
  return (
    <LegalLayout
      title="Obchodné podmienky"
      subtitle="Podmienky poskytovania digitalnych sluzieb - Kamil Frajtko, Boostio (zivnostnik/SZCO)."
      updated="1. januára 2024"
      sections={sections}
      navLinks={navLinks}
    />
  );
}
